/**
 * A 401 on the public recovery call is a failed reset, not an expired application session.
 * Authenticated self-change and admin reset use different URLs and still count as session expiry.
 */
export function shouldTreatAsSessionExpiry(status: number | undefined, url: string | undefined): boolean {
    if (status !== 401) {
        return false;
    }
    const path = (url || '').split('?')[0];
    return !path.endsWith('/api/user/password');
}
